// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"CeRequirementsBox_sectionContainer__3CBSQ","sectionTitle":"CeRequirementsBox_sectionTitle__BZbPb","form":"CeRequirementsBox_form__5T1sy"};